import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import SelectWinnerDrawerApp from '../select-winner-drawer-app';
import SelectedWinnersStore from '../../stores/selected-winners-store';
import ModalStore from 'contest/stores/modal-store';
import { showDrawer, removeWinner } from '../../actions/select-winner';
import { showModal } from 'contest/actions/modal-store-actions';
import constants from 'contest/data/constants';

const ConnectedSelectWinnerDrawerApp = connectToStores(
    SelectWinnerDrawerApp,
    [SelectedWinnersStore, ModalStore],
    (context) => {
        const store = context.getStore(SelectedWinnersStore);
        const entries = store.getEntries();
        return {
            isDrawerVisible: store.getShowDrawer(),
            onShowDrawer: () => context.executeAction(showDrawer),
            entries,
            onRemoveWinner: (index) => {
                const entries = store.getEntries();
                if (index < entries.length) {
                    context.executeAction(removeWinner, entries[index].designId);
                }
            },
            additionalWinnerCostTotal: store.getTotalForAdditionalWinners(),
            onConfirm: () =>
                context.executeAction(showModal, {
                    modal: constants.AWARD_WINNER_MODAL,
                    data: entries,
                }),
        };
    }
);

ConnectedSelectWinnerDrawerApp.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
};

export default ConnectedSelectWinnerDrawerApp;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/connected/connected-select-winner-drawer-app.jsx